import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Inscription } from 'src/app/interfaces/inscription';
import { ErrorService } from 'src/app/services/error.service';
import { InscriptionService } from 'src/app/services/inscription.service';

@Component({
  selector: 'app-inscription',
  templateUrl: './inscription.component.html',
  styleUrls: ['./inscription.component.css']
})
export class InscriptionComponent implements OnInit {
  listInscriptions: Inscription[] = [];
  loading = false;

  constructor(
    private _inscriptionService: InscriptionService,
    private toastr: ToastrService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.getListInscriptions();
  }

  getListInscriptions() {
    this.loading = true;
    this._inscriptionService.getListInscriptions().subscribe({
      next: (data: Inscription[]) => {
        this.listInscriptions = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de inscripciones:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deleteInscription(id: number) {
    this.loading = true;
    this._inscriptionService.deleteInscription(id).subscribe({
      next: () => {
        this.getListInscriptions();
        this.toastr.warning('La inscripcion fue eliminada con exito', 'Inscripcion eliminada');
      },
      error: (error) => {
        console.error('Error al eliminar la inscripcion:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }
}
